import {
  DiscordIcon,
  // GithubIcon,
  // RedditIcon,
  TwitterIcon,
  // YouTubeIcon,
} from './icons';

export const relatedLinks = [
  // {
  //   icon: <GithubIcon />,
  //   title: 'GitHub',
  //   link: 'https://github.com/toeverything/AFFiNE',
  // },
  {
    icon: <TwitterIcon />,
    title: 'X',
    link: 'https://x.com/muset_ai',
  },
  {
    icon: <DiscordIcon />,
    title: 'Discord',
    link: 'https://discord.gg/P6XXHb3KgW',
  },
  // {
  //   icon: <YouTubeIcon />,
  //   title: 'YouTube',
  //   link: 'https://www.youtube.com/@affinepro',
  // },
  // {
  //   icon: <RedditIcon />,
  //   title: 'Reddit',
  //   link: 'https://www.reddit.com/r/Affine/',
  // },
];
